module.exports = __webpack_public_path__ + "img/bcava-light.b3ce342f.png";